import React, { useState, Context, ReactElement, Component } from "react";


const TypeNameContext: Context<[string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>]> = React.createContext<[string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>]>([undefined, (_value: any) => { }]);

const TypeNameProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    // const sidebar_key = sessionStorage.getItem('sidebarKey');
    // let type_name_init = sidebar_key && sidebar_key.indexOf('_') > -1 ? sidebar_key.slice(0, sidebar_key.indexOf('_')) : '';
    const [type_name, set_type_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useState(sessionStorage.getItem('cluster_type') || undefined);
    return (
        <TypeNameContext.Provider value={[type_name, set_type_name]}>
            {props.children}
        </TypeNameContext.Provider>
    )
}

export { TypeNameContext, TypeNameProvider };